<template><ListFilter field="basin" :options="opts" label="Бассейн" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'BasinFilter', components:{ListFilter}, data(){ return { opts:['Волго-Уральский НГБ','Западно-Сибирский НГБ','Тимано-Печорский НГБ','Черное море'] } } }
</script>
